import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-regulation-description',
  templateUrl: './regulation-description.component.html',
  styleUrls: ['./regulation-description.component.scss']
})
export class RegulationDescriptionComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: string) {
  }
  showText(description: string): any {
    if (description) {
      const descArr = description.split('\n');
      const strArr = new Array<string>();
      descArr.forEach(item => {
        if (item) {
          strArr.push('<p>' + item + '</p>');
        }
      });
      description = strArr.join(' ');
    }
    return description;
  }
}
